import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent implements OnInit {



  caseStudyChecklist
  @Input('learner') learnerData;
  @Input('singleJob') jobData;
  @Input('assesment') assessmentPlanEdit;
  learnerId: any;
  jobId: any;
  assessmentEdit: any;
  loading = false
  isEdit:boolean = false;
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService
  ) { }

  ngOnInit() {
    if(!this.isEdit)
      this.createForm()
  }



  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue
    }

    if (changes.jobData && changes.jobData.currentValue) {
      this.jobId = changes.jobData.currentValue[0]
    }
    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
      this.assessmentEdit = changes.assessmentPlanEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);

      if (this.assessmentPlanEdit && this.assessmentPlanEdit.caseStudyChecklist) {
        this.isEdit = true
        this.createForm(this.assessmentEdit)
      }
      else {
        this.createForm()
      }
    }
  }



  // FORM CONTROL


  createForm(details?) {
    this.caseStudyChecklist = new FormGroup({
      include: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include : ''),
      include1: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include1 : ''),
      include2: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include2 : ''),
      include3: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include3 : ''),
      include4: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include4 : ''),
      include5: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include5 : ''),
      include6: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include6 : ''),
      include7: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include7 : ''),
      include8: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include8 : ''),
      include9: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include9 : ''),
      include10: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include10 : ''),
      include11: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include11 : ''),
      include12: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.include12 : ''),
      page: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page : ''),
      page1: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page1 : ''),
      page2: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page2 : ''),
      page3: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page3 : ''),
      page4: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page4 : ''),
      page5: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page5 : ''),
      page6: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page6 : ''),
      page7: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page7 : ''),
      page8: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page8 : ''),
      page9: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page9 : ''),
      page10: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page10 : ''),
      page11: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page11 : ''),
      page12: new FormControl((details && details.caseStudyChecklist) ? details.caseStudyChecklist.page12 : ''),
    })
  }



  // UTILITY

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  // API CALL


  submitForm() {
    console.log("form submit value", this.caseStudyChecklist.value);


    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId._id,
      version: true,
      details: {
        caseStudyChecklist: this.caseStudyChecklist.value,
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })
  }


}
